import request from '@/router/axios'
import env from '@/config/env'

/**
 * 查询支出/收款公司（供应商及其下属供应商）
 */
export const getAllLowMerchant = () => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/getAllLowMerchant',
    method: 'GET',
  })
}

/**
 * 根据支出公司获取车牌
 * @param spendingCompanyId
 */
export const getCar = (spendingCompanyId) => {
  return request({
    url: env.ferryUrl + `/settle-ticket-rule/car/${spendingCompanyId}`,
    method: 'GET',
  })
}

/**
* 获取线路名称
* @param id
*/
export const queryAllLowLine = (id) => {
  return request({
    url: env.ferryUrl + `/lineAdmin/getLineByMerchantIds?merchantId=${id}`,
    method: 'GET',
  })
}

/**
 * 获取票款结算规则分页
 * @param settleTicketRulePageDto
 */
export const settleTicketRulePage = (settleTicketRulePageDto) => {
  return request({
    url: env.ferryUrl + '/settle-ticket-rule/page',
    method: 'POST',
    data: settleTicketRulePageDto
  })
}

/**
 * 新增、编辑票款结算规则
 * @param data
 */
export const saveTicketSettle = (data) => {
  return request({
    url: env.ferryUrl + '/settle-ticket-rule/save-and-update',
    method: 'POST',
    data: data
  })
}

/**
 * 获取票款规则结算规则详情
 * @param data
 */
export const settleTicketDetails = (data) => {
  return request({
    url: env.ferryUrl + '/settle-ticket-rule/details',
    method: 'POST',
    data: data
  })
}

/**
 * 删除票款结算规则
 * @param data
 */
 export const removeSettleTicketRule = (data) => {
  return request({
      url: env.ferryUrl + '/settle-ticket-rule',
      method: 'DELETE',
      data: data
  })
}

/**
 * 删除票款结算单独配置规则
 * @param data
 */
 export const removeSettleTicketRuleConfig = (data) => {
  return request({
      url: env.ferryUrl + '/settle-ticket-rule/config',
      method: 'DELETE',
      data: data
  })
}
